<template>
  <div class>
    <STable
      ref="tableref"
      :selection="false"
      :url="url"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      :columns="columns"
      label-width="120px"
    />
  </div>
</template>
<script>
export default {
  name: 'Daozhaguanli',
  components: {},
  data() {
    return {
      url: '/business/notify/page',
      columns: [
        {
          label: '通知标题',
          prop: 'noticeName'
        },
        {
          label: '发送状态',
          prop: 'sendStatus'
        },
        {
          label: '发送方式',
          prop: 'sendMode'
        },
        {
          label: '发送时间',
          prop: 'sendTime'
        },
        {
          label: '创建时间',
          prop: 'createDate'
        }
      ],
      handles: {
        width: 220,
        btns: [
          {
            label: '修改',
            icon: 'el-icon-edit',
            permission: 'notice.news.update',
            before: (index, record) => {

            },
            getLabelStyle: record => {
              return record.sendStatus == '已发送' ? 'color: #c0c4cc;cursor: not-allowed;' : ''
            },
            getLabelDisabled: record => {
              return record.sendStatus == '已发送'
            },
            handle: resp => {
              this.$router.push({ path: './reviseInform', query: { data: resp.id }})
            }
          },
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'notice.news.details',
            before: (index, record) => {},
            handle: resp => {
              this.$router.push({ path: './informDetail', query: { data: resp.id }})
            }
          },
          {
            label: '删除',
            permission: 'notice.news.delete',
            style: 'color:red',
            url: '/business/notify/delete',
            method: 'delete',
            isConfirm: true,
            getLabelStyle: record => {
              return record.sendStatus != '已发送' ? 'color:red' : 'color: #c0c4cc;'
            },
            getLabelDisabled: record => {
              return record.sendStatus == '已发送'
            },
            before: (index, record) => {
              return {
                id: record.id
              }
            },
            handle: () => {
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success'
              })
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      query: [
        {
          label: '通知标题',
          prop: 'noticeName',
          placeholder: '请输入通知标题'
        },
        {
          label: '发送状态',
          prop: 'sendStatus',
          placeholder: '请选择发送状态',
          type: 'select',
          data: [
            {
              label: '待发送',
              value: '0'
            },
            {
              label: '已发送',
              value: '1'
            }
          ]
        },
        {
          label: '发送方式',
          prop: 'sendMode',
          placeholder: '请选择发送方式',
          type: 'select',
          data: [
            {
              label: 'App推送',
              value: '0'
            },
            {
              label: '短信推送',
              value: '1'
            },
            {
              label: '全部',
              value: '2'
            }
          ]
        }
        // {
        //   label: '发送时间',
        //   prop: 'sendTime',
        //   placeholder: '',
        //   type: 'date2'
        // }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'notice.news.add',
          type: 'primary',
          handle: resp => {
            this.$router.push('./addInformManagement')
          }
        }
      ]
    }
  },
  computed: {

  },
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="less" src="" scoped>

</style>



// WEBPACK FOOTER //
// src/views/informManagement/informmanagement.vue